<!-- デマンドの定期券は特別に予約するボタン -->
<template>
  <div :class="['footer', 'before-use', { 'standard-pass': isStandard }]">
    <div class="buttons">
      <FaceStartButton
        button-label="予約する"
        :is-standard="isStandard"
        @clicked="ncModeDemand()"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "ThePassLowerDemand",
  // TODO neModeDemand()をmixin→serviceに移行して使う
  props: {
    isStandard: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.standard-pass {
  position: relative;
  height: auto;
  bottom: auto;
}
</style>
